// 部署正式服 = 0, 部署测试服 = 1, 本地dev代理 = 2, 部署其他服务器=3 不能另外部署，否则不能天工登录
let profiles = 0;//选择build的参数


let config = {};
if (profiles == 0) {
    config.baseUrl = window.location.protocol + '//' + window.location.host + '/gateway/tbim';
    config.autoCDMUrl = { building: window.location.protocol + '//' + window.location.host + '/gateway/bdm' };
    config.loginTGurl = window.location.protocol + '//' + window.location.host + '/gateway/system';
} else if (profiles == 1) {
    config.baseUrl = window.location.protocol + '//' + window.location.host + '/tbim';
    config.autoCDMUrl = { building: window.location.protocol + '//' + window.location.host + '/bdm' };
    config.loginTGurl = window.location.protocol + '//' + window.location.host + '/system';
} else if (profiles == 2) {
    config.baseUrl = 'http://localhost:8080/api/tbim';
    config.autoCDMUrl = { building: 'http://10.1.40.112:1200/bdm' };
    //config.autoCDMUrl = { building: 'http://localhost:8080/api/bdm' };//webpack代理  其中api配置可改  前端http://localhost:8080 代理到后台http://10.1.40.112:1200
    config.loginTGurl = 'http://localhost:8080/api/system';           //代理配置 config->index.js
} else if (profiles == 3) {
    config.baseUrl = window.location.protocol + '//' + window.location.host + '/tbim';
    config.autoCDMUrl = { building: 'http://10.1.40.112:1200/bdm' };
    config.loginTGurl = 'http://10.1.40.112:1200/system';
}

/**
 * 全局常量、方法封装模块
 * 通过原型挂载到Vue属性
 * 通过 this.Global 调用
 */

// 后台管理系统服务器地址
export const baseUrl = config.baseUrl;
//autoCDM数据   代理配置 config->index.js
export const autoCDMUrl = config.autoCDMUrl;
//登录天工接口
export const loginTGurl = config.loginTGurl;



// 系统数据备份还原服务器地址
//export const backupBaseUrl = 'http://localhost:8002';

export const isNoServer = false;
export const isNoLogin = false;

export const projectInfo = {};//当前项目信息


export default {
    baseUrl,
    loginTGurl,
    autoCDMUrl,
    meshKey: "mid", //comid  //所有构件在tree transfer等组件上要用到的key
    ModelViewTreeLabel: "componentName"//构件树要显示的字段
};


// WEBPACK FOOTER //
// ./src/utils/global.js